export default "__VITE_ASSET__CjDnYquu__"